// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainBefore, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { createShipTo as createShipToApi } from "@insite/client-framework/Services/CustomersService";
import {
    chain,
    CreateShipTo,
    DispatchShipTosReset,
} from "@insite/client-framework/Store/Pages/Addresses/Handlers/CreateShipTo";

// XNG-Changes: FLIP-892 This handler being used to handle Create Ship to errors 
export const xCreateShipTo: typeof CreateShipTo = async (props: any) => {
    try {
        props.apiResult = await createShipToApi(props.apiParameter);
    } catch (error) {
        props.error = (error as any)?.errorMessage;
    }
};

export const excuteOnError = (props: any) => {
    if (props.error) {
        props.parameter.onError(props.error);
    }
};

export const xDispatchCompleteLoadShipTo = (props: any) => {
    if (props.error) {
        return;
    }
    DispatchShipTosReset(props);
};

replaceInChain(chain, CreateShipTo, xCreateShipTo);
addToChainBefore(chain, DispatchShipTosReset, excuteOnError);
replaceInChain(chain, DispatchShipTosReset, xDispatchCompleteLoadShipTo);
